/**
 * Capacitor Platform Detection Helpers
 *
 * Centralizes platform checks so components can adapt behavior
 * for native iOS vs web browser contexts.
 */
import { Capacitor } from '@capacitor/core'

/** True when running inside a native Capacitor shell (iOS/Android) */
export function isNative(): boolean {
  return Capacitor.isNativePlatform()
}

/** True when running on iOS specifically */
export function isIOS(): boolean {
  return Capacitor.getPlatform() === 'ios'
}

/** True when running in a web browser (not native) */
export function isWeb(): boolean {
  return Capacitor.getPlatform() === 'web'
}
